<template>
  <div class="navListWrap">
    <div
      v-for="(step, index) in stepList"
      :key="step.label"
      :class="['navItem', index === currentStep ? 'currentState' : (index < currentStep ? 'beforeState' : 'afterState')]">
      <span>{{step.label}}</span>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    stepList:{
      type: Array,
      default: []
    },
    currentStep:{
      type: Number,
      default: 0,
    }
  },
  data(){
    return{
    }
  }
}
</script>
<style lang="less" scoped>
.navListWrap{
  height: 100%;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  color: #FFFFFF;
  .navItem{
    position: relative;
    flex: 1;
    margin: 0 5px 0 0;
    // padding-left: 45px;
    text-align: center;
    font-size: 12px;
  }
  .navItem:last-of-type{
    margin: 0;
  }
  .navItem:not(:last-of-type):after{
    content: '';
    border-top: 17px solid transparent;
    border-bottom: 17px solid transparent;
    position: absolute;
    top: 0;
    right: -17px;
    z-index: 99;
  }
  .navItem:not(:first-of-type)::before{
    content: '';
    border-top: 17px solid transparent;
    border-bottom: 17px solid transparent;
    position: absolute;
    top: 0;
    border-left: 17px solid #FFFFFF;
    left: 0;
  }

}
.beforeState{
  background: @beforeColor;
}
.navItem.beforeState:after{
  border-left: 17px solid @beforeColor;
}
.currentState{
  background: @currentColor;
}
.navItem.currentState:after{
  border-left: 17px solid @currentColor;
}
.afterState{
  background: @afterColor;
  color: #333333;
}
.navItem.afterState:after{
  border-left: 17px solid @afterColor;
}
</style>